import { Instance, types } from 'mobx-state-tree'

export const Institutions = types.model('Institutions', {
  name: '',
  isBlocked: types.optional(types.boolean, false),
  finicityMeta: types.frozen(),
})

export type IInstitutionModel = Instance<typeof Institutions>
